import axios from 'axios';
import { showNotification } from '@mantine/notifications';
import config from '../config';
import { getLocalStorage, removeLocalStorage } from '../storage/localStorage';

const api = axios.create({
  baseURL: config.apiBaseUrl,
});

api.interceptors.request.use(
  (reqConfig) => {
    const auth = getLocalStorage('authorization');
    const token = auth?.token || auth?.accessToken;
    if (token) {
      reqConfig.headers['x-access-token'] = token;
    }
    return reqConfig;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.response?.config?.url || error?.config?.url || '';
    const isLogin = String(url).includes('/auth/login');

    if (isLogin) {
      return Promise.reject(error);
    }

    if (status === 401 || status === 403) {
      removeLocalStorage('authorization');
      showNotification({
        message:
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          'Session expired. Please log in again.',
        color: 'red',
      });
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      }
    } else {
      showNotification({
        message:
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          'Something went wrong',
        color: 'red',
      });
    }
    return Promise.reject(error);
  },
);

export default api;
